<template>
  <div>
    <h4>Siniestro: {{ claim.claim_company_reference }}</h4>
    <p>{{ claim.description }}</p>
    <div v-for="(item, index) in items">
      <b-card
        :bg-variant="tipoGestion(item.erp_id).background"
        :text-variant="tipoGestion(item.erp_id).text"
        title=""
        tag="article"
        class="mb-12"
      >
        <b-card-text>
          <b-avatar></b-avatar> {{ item.usuario }}&nbsp;&nbsp;&nbsp;
          <b-badge>{{ item.fecha_gestion }}</b-badge>
          <hr />
          <p>{{ item.descripcion }}</p>
          <p>{{ item.observaciones }}</p>
        </b-card-text>
      </b-card>
    </div>

    <hr />
    <moon-loader
      :loading="loadingTable"
      color="green"
      size="80px"
    ></moon-loader>
  </div>
</template>

<script>
import { insuranceClaimsService } from "@/_services";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
import moment from "moment";

export default {
  components: {
    MoonLoader: MoonLoader,
  },
  props: ["claim"],
  data() {
    return {
      items: [],
      emails: [],
      loadingTable: true,
    };
  },
  methods: {
    tipoGestion(tipo) {
      if (tipo == "EMAIL")
        return {
          background: "success",
          text: "white",
        };
      else
        return {
          background: "light",
          text: "",
        };
    },
  },
  async mounted() {
    this.loadingTable = true;
    this.items = await insuranceClaimsService.getClaimLog(this.claim.claim_id);
    var emailList = await insuranceClaimsService.getEmailsFromClaim(
      this.claim.claim_id
    );
    var allClaimLog = emailList.concat(this.items);
    this.items = insuranceClaimsService.shortClaimLogByDate(allClaimLog);
    this.totalRows = this.items.length;
    this.loadingTable = false;
  },
  watch: {
    claim: async function (newVal) {
      // watch it
      console.log("Prop changed: ", newVal);
      this.loadingTable = true;
      this.items = await insuranceClaimsService.getClaimLog(
        this.claim.claim_id
      );
      var emailList = await insuranceClaimsService.getEmailsFromClaim(
        this.claim.claim_id
      );
      var allClaimLog = emailList.concat(this.items);
      this.items = allClaimLog; 
      this.totalRows = this.items.length;
      this.loadingTable = false;
    },
  },
};
</script>


<style>
.badge {
  color: #fff;
  background-color: #85d1a1 !important;
}



</style>
